import axios from 'axios'

// create an axios instance
const service = axios.create({
  baseURL: 'https://course.muketang.com/',
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000, // request timeout
  params: {},
  data: {}
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    if (!res.code) {
      return res
    } else {
      // alert(res.errorMsg)
      return Promise.reject(res)
    }
  },
  error => {
    console.log('err' + error) // for debug
    // alert(error)
    return Promise.reject(error)
  }
)

function get ({ url, params = {}, data = {}, type = 'get', responseType = '' }, handleError) {
  return new Promise((resolve, reject) => {
    service({ url, params, data, method: type, responseType }).then(res => {
      resolve(res)
    }).catch(err => {
      if (handleError) {
        reject(err)
      }
    })
  })
}

export default get
